export default {
  custom: {
    'Competition Name': null,
    'Match Date': null,
    'Match ID': null,
    'Round Number': null,
    'Team 1': null,
    'Team 2': null,
    'Venue Name': null,
  },
  sportsTg: {
    teamName: 'Team Name',
    uniqueCode: 'Team Code',
    teamSection: 'Competition Name',
    season: 'Season',
    'teamManager.fullName': 'Contact Person',
    'teamManager.mobile': 'Mobile',
    'teamManager.email': 'Email',
    'teamManager.uniqueCode': 'Contact Code',
    'teamContact.fullName': 'Contact 2 Name',
    'teamContact.mobile': 'Contact 2 Mobile',
    'teamContact.email': 'Contact 2 Email',
    'teamContact.uniqueCode': 'Contact 2 Code',
  },
  playHq: {
    teamName: 'Team Name',
    uniqueCode: 'Team Code',
    teamSection: 'Competition Name',
    season: 'Season',
    'teamManager.fullName': 'Contact Person',
    'teamManager.mobile': 'Mobile',
    'teamManager.email': 'Email',
    'teamManager.uniqueCode': 'Contact Code',
    'teamContact.fullName': 'Contact 2 Name',
    'teamContact.mobile': 'Contact 2 Mobile',
    'teamContact.email': 'Contact 2 Email',
    'teamContact.uniqueCode': 'Contact 2 Code',
  },
  fixi: {
    teamName: 'Team Name',
    uniqueCode: 'Team Code',
    teamSection: 'Competition Name',
    season: 'Season',
    'teamManager.fullName': 'Contact Person',
    'teamManager.mobile': 'Mobile',
    'teamManager.email': 'Email',
    'teamManager.uniqueCode': 'Contact Code',
    'teamContact.fullName': 'Contact 2 Name',
    'teamContact.mobile': 'Contact 2 Mobile',
    'teamContact.email': 'Contact 2 Email',
    'teamContact.uniqueCode': 'Contact 2 Code',
  },
  teammo: {
    teamName: 'Team Name',
    uniqueCode: 'Team ID',
    teamSection: 'Section Name',
    season: 'Season Name',
    'teamManager.fullName': 'Primary Contact Name',
    'teamManager.mobile': 'Primary Contact Mobile',
    'teamManager.email': 'Primary Contact Email',
    'teamManager.uniqueCode': 'Primary Contact ID',
    'teamContact.fullName': 'Secondary Contact Name',
    'teamContact.mobile': 'Secondary Contact Mobile',
    'teamContact.email': 'Secondary Contact Email',
    'teamContact.uniqueCode': 'Secondary Contact ID',
  },
};
